import React, { useState, useEffect, useRef } from "react";

import * as moment from "moment-timezone";

import { Link, withRouter } from "react-router-dom";

import Layout from "../../components/Layout";

import api from "../../services/api";
import { apiCRMv3 } from "../../services/api";
import Swal from "sweetalert2";

const ReportAllUsers = props => {
    const [showAlert, setShowAlert] = useState(false);
    const [alertTitle, setAlertTitle] = useState("");
    const [alertText, setAlertText] = useState("");
    const [alertVariant, setAlertVariant] = useState("");
    const [fileURLAllUsers, setFileURLAllUsers] = useState("");
    const [fileNameAllUsers, setFileNameAllUsers] = useState("");
    const [loaded, setLoaded] = useState(true);

    useEffect(function () { }, []);

    function onSubmitReportCards(event) {
        event.preventDefault();

        async function getReportAllUsers() {
            try {
                setLoaded(false);
                const responseGetReportAllUsers = await api.get(
                    `/reports/all-users`,
                    {
                        responseType: "blob"
                    }
                );

                if (
                    responseGetReportAllUsers.data.error ||
                    responseGetReportAllUsers.status === 500
                ) {
                    setShowAlert(true);
                    setAlertTitle("Problemas ao gerar o relatório.");
                    setAlertText(responseGetReportAllUsers.data.data.message);
                    setAlertVariant("danger");

                    setLoaded(true);
                } else {
                    let fileName = responseGetReportAllUsers.headers[
                        "content-disposition"
                    ].split(";")[1];
                    fileName = fileName.slice(
                        fileName.indexOf('"'),
                        fileName.length - 1
                    );

                    setFileURLAllUsers(
                        window.URL.createObjectURL(
                            new Blob([responseGetReportAllUsers.data])
                        )
                    );
                    setFileNameAllUsers(fileName);

                    setShowAlert(true);
                    setAlertTitle("Relatório de usuários gerado com sucesso!");
                    setAlertText(`Clique no botão abaixo para fazer download!`);
                    setAlertVariant("success");

                    setLoaded(true);
                }
            } catch (err) {
                console.log(err);
                setShowAlert(true);
                setAlertTitle("Problemas ao gerar o relatório.");
                setAlertText("Por favor contate o suporte!");
                setAlertVariant("danger");

                setLoaded(true);
            }
        }

        getReportAllUsers();
    }

    async function getReportCrmDataAllBranches() {
        try {
            const start = moment.tz("America/Sao_Paulo").startOf("month").format("YYYY-MM-DD");
            const end = moment.tz("America/Sao_Paulo").endOf("month").format("YYYY-MM-DD");
            setLoaded(false);
            const response = await apiCRMv3.get(`/crm-analysis/export-all-branches`, {
                params: {
                    start,
                    end
                },
                responseType: 'blob'
            });
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `dados_crm_todas_filiais.xlsx`); // nome do arquivo
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);

            Swal.fire("Sucesso!", "O relatório foi baixado com sucesso!", "success");

            setLoaded(true);

        } catch (err) {
            console.log(err);
            Swal.fire("Erro!", "Problemas ao gerar o relatório. Por favor contate o suporte!", "error");
            setLoaded(true);
        }
    }

    return (
        <Layout
            menuActive="dashboard"
            pageTitle="Relatório de Todos os Usuários"
        >
            <div className="row">
                <div className="col-xs-12">
                    <div className="card">
                        <div className="card-header">
                            <div className="card-title">
                                <small>
                                    <Link
                                        className="label label-default"
                                        to="/dashboard"
                                    >
                                        Dashboard
                                    </Link>{" "}
                                </small>{" "}
                                <span className="label label-success">
                                    Relatório de Todos os Usuários
                                </span>
                            </div>
                        </div>
                        <div
                            className={`card-body table-responsive ${loaded ? "" : "__loading"
                                }`}
                        >
                            <div className="row" style={{padding:"10px"}}>
                                <form onSubmit={onSubmitReportCards}>
                                    <div className="col-xs-4">
                                        <button
                                            className="btn btn-primary btn-large"
                                            type="submit"
                                        >
                                            Gerar!
                                        </button>
                                        &nbsp;&nbsp;
                                        <button className="btn btn-success btn-large"
                                            type="button" onClick={(e) => {
                                                getReportCrmDataAllBranches()
                                            }}>
                                            Exportar Dados CRM Filail
                                        </button>
                                    </div>
                                </form>
                            </div>
                            {fileURLAllUsers !== "" ? (
                                <a
                                    href={fileURLAllUsers}
                                    download={fileNameAllUsers}
                                >
                                    <button
                                        className="btn btn-success btn-large"
                                        type="submit"
                                    >
                                        Download!
                                    </button>
                                </a>
                            ) : null}

                            <br />

                            <div className="loader-container text-center">
                                <div className="icon">
                                    <div className="sk-wave">
                                        <div className="sk-rect sk-rect1"></div>
                                        <div className="sk-rect sk-rect2"></div>
                                        <div className="sk-rect sk-rect3"></div>
                                        <div className="sk-rect sk-rect4"></div>
                                        <div className="sk-rect sk-rect5"></div>
                                    </div>
                                </div>
                                <div className="title">Carregando</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default withRouter(ReportAllUsers);
